/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import axios from 'axios';
import { isAfter } from 'date-fns';
import { SortOrder } from '@/Core/config/query-mappings';
import { ActionFiltersTranslated, TypeFiltersTranslated } from '../config/scheduleds-filters';

function isPastDue(scheduledDueAt) {
  const now = new Date();
  const dueAt = new Date(scheduledDueAt);
  return isAfter(now, dueAt);
};

export default {
  namespaced: true,

  state: {
    total: null,
    pageSize: 10,
    isLoading: false,
    scheduleds: [],
    scheduledsError: null,
  },

  getters: {
    scheduledsList: (state) => {
      return state.scheduleds.map(scheduled => ({
        ...scheduled,
        isPastDue: isPastDue(scheduled.due_at),
      }));
    },
  },

  mutations: {
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    setScheduleds(state, payload) {
      state.scheduleds = payload.items;
      state.total = payload.total;
    },
    setScheduledsError(state, payload) {
      state.scheduledsError = payload;
      state.isLoading = false;
    },
  },

  actions: {
    async findScheduleds({ commit, rootState }, payload) {
      const {
        contactId,
        page,
        sortOrder,
        filter,
        typeFilter,
      } = payload;

      const { scheduledsPageSize } = rootState.preferences;

      const query = {
        status: filter,
        $skip: scheduledsPageSize * (page - 1),
        $limit: scheduledsPageSize,
        contact_id: contactId,
        action: TypeFiltersTranslated[typeFilter],
      };

      let { sortField } = payload;
      if (!sortField) {
        sortField = 'due_at';
        if (query.status === ActionFiltersTranslated.Completed) {
          sortField = 'updated_at';
        }
      }

      if (sortOrder) {
        query[`$sort[${sortField}]`] = SortOrder[sortOrder];
      }

      try {
        commit('setIsLoading', true);

        const { data } = await axios.get(
          `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/scheduled/system-events`,
          { params: query },
        );

        const { total, data: respData } = data;
        commit('setScheduleds', { items: respData, total });
      } catch (error) {
        commit('setScheduledsError', error.message);
      }

      commit('setIsLoading', false);
    },
    async completeScheduled({ commit, dispatch }, payload) {
      const { selectedAction, ids, queryParams } = payload;

      try {
        commit('setIsLoading', true);

        await axios.put(
          `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/scheduled/system-events/bulk`,
          {
            status: selectedAction,
            system_event_ids: ids,
          },
        );

        dispatch('findScheduleds', queryParams);
      } catch (error) {
        commit('setScheduledsError', error.message);
      }

      commit('setIsLoading', false);
    },
    clearScheduledsError({ commit }) {
      commit('setScheduledsError', null);
    },
  },
};
